import { render } from "./ReviewList.vue?vue&type=template&id=5bbb0ad4&scoped=true"
import script from "./ReviewList.vue?vue&type=script&lang=js"
export * from "./ReviewList.vue?vue&type=script&lang=js"

import "./ReviewList.vue?vue&type=style&index=0&id=5bbb0ad4&lang=scss&scoped=true"

import exportComponent from "/var/www/hrms.automaxion.io/public_html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bbb0ad4"]])

export default __exports__